import { isArray } from 'lodash';

export const serializeCloseReason = reason => ({
  id: reason.id && String(reason.id),
  title: reason.title,
  isSuccess: reason.is_success,
  isActive: reason.is_active,
});

export const serializeCloseReasons = reasons => {
  if (!isArray(reasons) && reasons.length < 1) return null;

  return reasons.map(reason => serializeCloseReason(reason));
};
